import router from "@/router/index";
import axios from "axios";
import type { AxiosError, AxiosResponse } from "axios";

let apiConfig = {
  baseURL: import.meta.env.VITE_API_SERVER_URL + import.meta.env.VITE_APP_API_URL,
  withCredentials: true,
};

const Api = axios.create(apiConfig);

function stopChain<T = never>(): Promise<T> {
  return new Promise<T>(() => {});
}

Api.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    const status = error.response?.status;

    if (!status) {
      return Promise.reject(error);
    }

    if (status === 503) {
      if (router.currentRoute.value.name !== "Wartung") {
        router.push({ name: "Wartung" });
      }
      return stopChain();
    }

    switch (status) {
      case 400:
        router.push({ path: "/error/400" });
        break;
      case 402:
        router.push({ path: "/error/402" });
        break;
      case 403:
        router.push({ path: "/error/403" });
        break;
      case 405:
        router.push({ path: "/error/405" });
        break;
      default:
        console.error(`Unexpected error status: ${status}`);
        break;
    }

    return Promise.reject(error);
  },
);

export default Api;
